export function setupState () {
	/* #### Simple State Machine #### */
	window.welcome = {}
	window.welcome.session = { authenticated: false, token: '' }
	window.welcome.loaded = false;
	window.user = {}
}
